import { Controller } from "@hotwired/stimulus"

// Копирует текст из data-clipboard-text-value в буфер обмена
export default class extends Controller {
  static targets = ["label"]
  static values = { text: String, done: { type: String, default: "Скопировано" } }

  async copy() {
    await navigator.clipboard.writeText(this.textValue)
    if (!this.hasLabelTarget) return

    const original = this.labelTarget.textContent
    this.labelTarget.textContent = this.doneValue
    setTimeout(() => { this.labelTarget.textContent = original }, 2000)
  }
}
